import { useLocation } from 'react-router-dom';
import PaystubPreview from 'components/paystub/paystub-preview';

const PaystubEmployeePreview = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const id = searchParams.get('id');
  return (
    <div>
      <PaystubPreview id={id ?? ''} />
    </div>
  );
};

export default PaystubEmployeePreview;
